import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import { Spanish } from 'flatpickr/dist/l10n/es.js';

export default class extends Controller {
  static targets = ["calendario"];
  static values = {
    fechas: Array,
    totales: Array,
    id: String,
    baseurl: String,
  };

  connect() {
    const id = this.idValue;
    const burl = this.baseurlValue;
    const arraySpanish = [];

    this.totalesValue.forEach((fecha) => {
      const fechaString = fecha.split('T')[0]; 
      const [year, month, day] = fechaString.split('-');
      const fechaNueva = new Date(year, parseInt(month) - 1, parseInt(day));
      const opcionesFecha = { month: "long", day: "numeric", year: "numeric" };
      const [dayEs, monthEs, yearEs] = fechaNueva.toLocaleDateString("es-ES", opcionesFecha).split(" de ");
      const formattedDate = `${monthEs.charAt(0).toUpperCase() + monthEs.slice(1)} ${dayEs.replace(',', '')}, ${yearEs}`;
      arraySpanish.push(formattedDate);
    });

    const urlParams = new URLSearchParams(window.location.search);
    const fechaSeleccionada = urlParams.get('fecha');

    if (!this.flatpickrInstance) {
      this.flatpickrInstance = flatpickr(this.element, {
        enableTime: false,
        inline: true,
        locale: 'es',
        dateFormat: "Y-m-d",
        defaultDate: fechaSeleccionada,
        
        onDayCreate: function (dObj, dStr, fp, dayElem) {
          dayElem.addEventListener("click", function (event) {
            event.preventDefault(); 
            
            const meses = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
            const mes = meses[dayElem.dateObj.getUTCMonth()];
            const dia = dayElem.dateObj.getDate();
            const año = dayElem.dateObj.getFullYear();
            const fecha = `${año}-${mes}-${dia}`;

            fp.setDate(dayElem.dateObj, false);

            const baseUrl = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
              ? "http://localhost:3000"
              : burl;

            const urlDestino = `${baseUrl}/visitas_efector/${id}/calendario/${fecha}`;

            const frame = document.getElementById("tarjetas_visitas");
            if (frame) {
              frame.src = urlDestino;
            }
          });
        },

        onMonthChange: function (selectedDates, dateStr, instance) {
          const mesNuevo = instance.currentMonth; // Base 0 (0 = Enero, 5 = Junio)
          const añoNuevo = instance.currentYear;
          
          // Obtener los datos reales del día de hoy en el mundo real
          const hoyReal = new Date();
          const esMesActual = (mesNuevo === hoyReal.getMonth() && añoNuevo === hoyReal.getFullYear());

          let fechaDefecto;
          let nuevaFechaObj;

          if (esMesActual) {
            // Inteligente: Si volvió al mes vigente, seleccionamos HOY (ej: 30 de Junio)
            nuevaFechaObj = hoyReal;
            fechaDefecto = `${hoyReal.getFullYear()}-${hoyReal.getMonth() + 1}-${hoyReal.getDate()}`;
          } else {
            // Si es otro mes, cae en el día 1 por defecto
            nuevaFechaObj = new Date(añoNuevo, mesNuevo, 1);
            fechaDefecto = `${añoNuevo}-${mesNuevo + 1}-1`;
          }
          
          // Forzar la selección visual en el calendario de forma dinámica
          instance.setDate(nuevaFechaObj, false);

          const baseUrl = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
            ? "http://localhost:3000"
            : burl;

          const urlDestino = `${baseUrl}/visitas_efector/${id}/calendario/${fechaDefecto}`;

          const frame = document.getElementById("tarjetas_visitas");
          if (frame) {
            frame.src = urlDestino;
          }

          // Volvemos a pintar los puntitos destacados
          setTimeout(() => {
            const calendarContainer = instance.calendarContainer;
            const days = calendarContainer.querySelectorAll(".flatpickr-day");
            days.forEach(function (day) {
              const fecha = day.getAttribute("aria-label");
              if (fecha && arraySpanish.includes(fecha)) {
                day.classList.add("destacado");
              }
            });
          }, 10); 
        },

        onReady: function (selectedDates, dateStr, instance) {
          const calendarContainer = instance.calendarContainer;
          const days = calendarContainer.querySelectorAll(".flatpickr-day");
          days.forEach(function (day) {
            const fecha = day.getAttribute("aria-label");
            if (fecha && arraySpanish.includes(fecha)) {
              day.classList.add("destacado");
            }
          });
        },

        onChange: function (selectedDates, dateStr, instance) {
          const calendarContainer = instance.calendarContainer;
          const days = calendarContainer.querySelectorAll(".flatpickr-day");
          days.forEach(function (day) {
            const fecha = day.getAttribute("aria-label");
            if (fecha && arraySpanish.includes(fecha)) {
              day.classList.add("destacado");
            }
          });
        },
      });
    }
  }

  disconnect() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
    }
  }
}